import React from 'react'
import { array } from 'prop-types'
import SimpleList from '@/component/Primitive/SimpleList'

const ArticleLayoutRelatedContent = ({ relatedContent }) => {
  if (!relatedContent || !relatedContent.length) return null

  const formattedArticles = relatedContent?.map((article) => ({
    content: article.headline,
    href: article.fullUrlPath,
    tags: article.category ? [{ title: article.category }] : null,
    eventBaseSlug: article.eventBaseSlug
  }))

  return (
    <SimpleList
      listData={formattedArticles}
      titlePrimary="Related"
      titleSecondary="Content"
    />
  )
}

ArticleLayoutRelatedContent.propTypes = {
  relatedContent: array
}

export default ArticleLayoutRelatedContent
